export interface PlayerAccountResponseStatus {
    ErrorCode: number;
    ErrorMessage: string;
}

export enum PlayerAccountStatusValue {
    Required = "Required",
    Approved = "Approved",
    NotRequired = "Not required",
}

export interface PlayerAccountResponseAccount {
    FirstName: string;
    LastName: string;
    Address: string;
    City: string;
    ZipCode: string;
    Email: string;
    Phone: number;
    Birthday: Date;
    Citizenship: string;
    BankAccountVerificationState: boolean;
    DeleteDate: Date;
    DisableAccountDate: Date;
    DisableAccountReason: string;
    LastModifiedDate: Date;
    LimitedAccountTypeStatus: string;
    EmailVerificationStatus: PlayerAccountStatusValue;
    PaymentMethodVerificationStatus: PlayerAccountStatusValue;
    ResponsibleGamingLimitsStatus: PlayerAccountStatusValue;
    POSVerificationStatus: PlayerAccountStatusValue;
    PlayerComplianceTrackingCDDStatus: string;
    PersonNationalIDVerificationStatus: PlayerAccountStatusValue;
    RegistrationDate: Date;
    RegistrationVerticalID: number;
    HID: string;
    RegulatorPopulationRegistryStatus: string;
    RegulatorGamblingRegistryStatus: string;
    IDVerificationStatus: string;
    IsHighRiskCountryAFRAttached: boolean;
    IsCitizenshipDBAFRAttached: boolean;
    IsSanctionListAFRAttached: boolean;
    HasApprovedDeposits: boolean;
    HasPendingDeposits: boolean;
    HasDeclinedDeposits: boolean;
    AccountTerminationStatus: string;
    AccountTerminationSuspensionReason: string;
}

export interface PlayerAccountResponse {
    TempAccountStatus: PlayerAccountResponseAccount;
    Header: PlayerAccountResponseStatus;
}
